var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHomeBlue = function SvgHomeBlue(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6EADDD",
    d: "M19.46 8.699v-.001L11.3.54C10.954.192 10.49 0 10 0c-.492 0-.954.191-1.302.54L.543 8.692l-.008.009c-.715.718-.713 1.883.003 2.6.327.327.76.517 1.222.537.018.002.038.002.057.002h.325v6.004c0 1.188.966 2.155 2.155 2.155h3.192c.323 0 .585-.262.585-.586v-4.707c0-.542.442-.983.984-.983h1.882c.543 0 .984.44.984.983v4.707c0 .324.262.586.585.586h3.192c1.189 0 2.155-.967 2.155-2.155v-6.004h.302c.491 0 .954-.191 1.302-.539.717-.718.717-1.885 0-2.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M19.46 8.699v-.001L11.3.54C10.954.192 10.49 0 10 0v13.724h.941c.543 0 .984.44.984.983v4.707c0 .324.262.586.585.586h3.192c1.189 0 2.155-.967 2.155-2.155v-6.004h.302c.491 0 .954-.191 1.302-.539.717-.718.717-1.885 0-2.603z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H20V20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-blue.fe36f5d4.svg";
export { ForwardRef as ReactComponent };